import { SwitchType } from "@components/inputs/switch/Switch";
import { EntitySetName, EntityTypeName, PrParentalLeaveEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { setDefByEntityType } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import ParentalLeaveFormView from "@pages/payroll/socialEvents/eventTypes/ParentalLeaveFormView";
import { SocialEventGroup } from "@pages/payroll/socialEvents/SocialEvents.types";
import i18next from "i18next";
import { cloneDeep } from "lodash";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import { BasicInputSizes, FieldType } from "../../../../enums";
import { addFormDef, getFormGroup } from "../../../../views/formView/Form.utils";
import { addSubmissionTableDefinitions, getDefinitions as commonDef, getSocialEventsFormDef } from "../SocialEventsDef";

export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const d = cloneDeep(getSocialEventsFormDef(ParentalLeaveFormView, PrSocialEventTypeCode.ParentalLeave, context));
    const generalGroup = getFormGroup(d, SocialEventGroup.General);

    addFormDef(d, PrParentalLeaveEventEntity.DateEventStart, {
        type: FieldType.Date,
        width: BasicInputSizes.L,
        label: i18next.t("SocialEvents:Form.DateOfEntry"),
    });

    addFormDef(d, PrParentalLeaveEventEntity.DateEventEnd, {
        type: FieldType.Date,
        isRequired: true,
        width: BasicInputSizes.L,
        label: i18next.t("SocialEvents:Form.ExpectedTermination"),
    });

    addFormDef(d, PrParentalLeaveEventEntity.DateOfChildbirth, {
        type: FieldType.Date,
    });

    addFormDef(d, PrParentalLeaveEventEntity.IsMaternityLeaveTakenBefore, {
        type: FieldType.Switch,
        fieldSettings: {
            type: SwitchType.YesNo
        },
        defaultValue: true,
        affectedFields: [
            { id: PrParentalLeaveEventEntity.IsMultipleChildbirth }
        ],
    });

    addFormDef(d, PrParentalLeaveEventEntity.IsMultipleChildbirth, {
        type: FieldType.Switch,
        fieldSettings: {
            type: SwitchType.YesNo
        },
        isVisible: (args) => !args.storage.getValueByPath(PrParentalLeaveEventEntity.IsMaternityLeaveTakenBefore),
    });

    generalGroup.rows = [[
        { id: PrParentalLeaveEventEntity.Employee },
        { id: PrParentalLeaveEventEntity.Employment },
    ], [
        { id: PrParentalLeaveEventEntity.DateEventStart },
        { id: PrParentalLeaveEventEntity.DateEventEnd },
        { id: PrParentalLeaveEventEntity.DateOfChildbirth },
    ], [
        { id: PrParentalLeaveEventEntity.IsMaternityLeaveTakenBefore }
    ], [
        { id: PrParentalLeaveEventEntity.IsMultipleChildbirth },
    ]];

    // Table tabs on the end of the form
    addSubmissionTableDefinitions(d);

    return {
        ...d,
        entitySet: EntitySetName.PrParentalLeaveEvents
    };
};

getDefinitions.translationFiles = [
    ...commonDef.translationFiles,
    getEnumNameSpaceName(EntityTypeName.PrParentalLeaveEvent)
];
setDefByEntityType(EntityTypeName.PrParentalLeaveEvent, getDefinitions);